import {defineAsyncComponent} from 'vue';

// Màn hình kiểm tra xác thực 2 lớp
const CheckTwoFactorMeinvoice = defineAsyncComponent(() =>
  import('@/views/invoice/connectMeinvoice/twoFactor/CheckTwoFactorMeinvoice.vue'),
);
const VoucherPostedInvoice = defineAsyncComponent(() => import('@/views/invoice/voucherPosted/VoucherPostedInvoice.vue'));
const CreateDVCPopupInvoice = defineAsyncComponent(() => import('@/views/invoice/createDVCFromInvoice/CreateDVCPopupInvoice.vue'));
const ChooseMajorInvoice = defineAsyncComponent(() => import('@/views/invoice/chooseMajorInvoice/ChooseMajorInvoice.vue'));
// Màn hình hoá đơn chi tiết
const InbotInvoiceDetail = defineAsyncComponent(() => import('@/views/invoice/invoices/InbotInvoiceDetail.vue'));
const DVCFileDetail = defineAsyncComponent(() => import('@/views/etreasury/DVCFile/DVCFileDetail.vue'));

// Lâp chứng từ
const CreateVoucher = defineAsyncComponent(() => import('@/views/invoice/createVoucher/CreateVoucher.vue'));

const ChangeReferenceInvoice = defineAsyncComponent(() => import('@/views/invoice/changeReferenceInvoice/ChangeReferenceInvoice.vue'));
export function invoiceRegister(app) {
  app.component('CheckTwoFactorMeinvoice', CheckTwoFactorMeinvoice);
  app.component('VoucherPostedInvoice', VoucherPostedInvoice);
  app.component('CreateDVCPopupInvoice', CreateDVCPopupInvoice);
  app.component('ChooseMajorInvoice', ChooseMajorInvoice);
  app.component('CheckTwoFactorMeinvoice', CheckTwoFactorMeinvoice);
  app.component('InbotInvoiceDetail', InbotInvoiceDetail);
  app.component('DVCFileDetail', DVCFileDetail);
  app.component('ChangeReferenceInvoice', ChangeReferenceInvoice);
  app.component('CreateVoucher', CreateVoucher);
}
